/**
 * N° invoice visible: correlativo (booking), sin prefijo INV-PTC/PTB ni año.
 * Ej. INV-PTC-55555-2026 → 55555
 */
export function invoiceNumberCorrelativo(raw) {
  const t = String(raw ?? '').trim();
  if (!t) return '';
  const withYear = t.match(/^INV-(?:PTC|PTB)-(.+)-(\d{4})$/i);
  if (withYear) return withYear[1];
  const noYear = t.match(/^INV-(?:PTC|PTB)-(.+)$/i);
  if (noYear) return noYear[1];
  return t;
}

/** Cabecera PDF (mismo correlativo que invoiceNumberCorrelativo). */
export function invoiceNumberForHeader(raw) {
  return invoiceNumberCorrelativo(raw);
}

/** Solo vista previa PDF: identificador del formulario o, si vacío, booking. */
export function numeroParaVistaPrevia(identificador, booking) {
  const n = invoiceNumberCorrelativo(identificador);
  if (n) return n;
  return sugerirNumeroInvoiceDesdeBooking(booking);
}

/** Booking normalizado para sugerir N° invoice al crear prefactura. */
export function sugerirNumeroInvoiceDesdeBooking(booking) {
  const bk = String(booking || '')
    .trim()
    .replace(/\s+/g, '-');
  return bk || 'NEW';
}
